import React from 'react'
import {
  IssueContainer,
  InnerIssueContainer,
  MainContent,
  IssueTitle,
  SidebarP,
  Sidebar,
  SidebarHeader,
  SidebarSubheader,
  CloseButton
} from '.'

interface Props {
  handleClose: () => void
}

export default function StudentsCard({ handleClose }: Props) {
  return (
    <IssueContainer>
      <InnerIssueContainer>
        <MainContent>
          <IssueTitle>Affordable, Equitable Higher Education</IssueTitle>
          <SidebarP>
            As states slash funding for higher education, colleges and universities have responded by sharply raising tuition and cutting
            educational services. This has left over 45 million students across the country burdened with a lifetime of debt. We must
            recommit to quality, affordable higher education by making public colleges and universities tuition-free. While politicians have
            prioritized corporate tax cuts and bank bail-outs, Justin will fight for a one-time cancellation of student loan debt for young
            people across the country.
          </SidebarP>
          <SidebarP>
            We must address the historic inequalities that black Americans face in obtaining higher education. Justin will fight for
            investment in HBCUs like Nashville’s Tennessee State University, American Baptist College, Meharry Medical College, and Justin’s
            alma mater Fisk University. HBCUs across the country must be fully funded and affordable for students, particularly now when
            many face funding crises because of a lack of leadership in Washington.
          </SidebarP>
        </MainContent>
        <Sidebar>
          {/* <SidebarHeader>JUSTIN SUPPORTS</SidebarHeader>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/3472/text">
            H.R. 3472 - College for All Act (18)
          </SidebarSubheader>
          <SidebarP>Free public colleges and universities.</SidebarP> */}
          {/* <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/1766">
            HR 1766 - College Transparency Act (118)
          </SidebarSubheader>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/4674">
            HR 4674 - College Affordability Act (85)
          </SidebarSubheader> */}
          <SidebarHeader>RESOURCES</SidebarHeader>

          <SidebarSubheader href="https://heller.brandeis.edu/iasp/pdfs/racial-wealth-equity/racial-wealth-gap/stallingdreams-how-student-debt-is-disrupting-lifechances.pdf">
            How Student Debt is Disrupting Life Chances and Widening the Racial Wealth Gap
          </SidebarSubheader>
          <SidebarSubheader href="https://www.cbpp.org/research/state-budget-and-tax/a-lost-decade-in-higher-education-funding">
            A Lost Decade in Higher Education Funding
          </SidebarSubheader>
          <SidebarSubheader href="https://www.insidehighered.com/quicktakes/2019/10/15/hbcus-plan-cuts-after-congress-misses-funding-deadline">
            HBCUs Plan Cuts Congress Misses Funding Deadline
          </SidebarSubheader>
        </Sidebar>
      </InnerIssueContainer>
      <CloseButton onClick={handleClose}>CLOSE</CloseButton>
    </IssueContainer>
  )
}
